








































import { mixin as clickaway } from 'vue-clickaway';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { decodeHTML } from '../utils/decodeHTML';
import SelectPopover from '@/components/SelectPopover.vue';

@Component({ components: { SelectPopover }, mixins: [clickaway] })
export default class ContextMenu extends Vue {
  @Prop({ default: true }) enabled!: boolean;

  @Prop({ type: String }) userName!: string;

  @Prop({ type: String }) userEmail!: string;

  expanded = false;

  onFocusOut(event: FocusEvent) {
    //check if the new target is not a child of the context menu
    const relatedTarget = event.relatedTarget as HTMLElement;
    if (relatedTarget && !this.$el.contains(relatedTarget)) {
      this.collapse();
    }
  }

  toggleExpand() {
    if (!this.enabled) {
      return;
    }

    this.expanded = !this.expanded;
  }

  collapse() {
    this.expanded = false;
  }

  getDecodedHTMLValue(value: string) {
    return decodeHTML(value);
  }
}
